import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import dayjs from 'dayjs'

import { logErrorAsync } from '_lib/utility.js'

import { Block } from '.'
import IconAnalytics from './icons/icon-analytics'

import { getRecentInsights } from '_services/dashboard'

async function getInsights(user) {
  try {
    const insights = await getRecentInsights()
    const byUser = insights.filter(({ createdBy }) => createdBy === user)
    return byUser.slice(0, 5)
  } catch (error) {
    logErrorAsync(error)
    return []
  }
}

const Card = ({ report }) => {
  const { audienceName, updatedAt, _id, createdBy } = report
  return (
    <div className="ai-card">
      <div className="ai-card__icon">
        <IconAnalytics size="30px" fill="#13682B" />
      </div>
      <div className="ac-card__meta">
        <Link to={`/audience/${_id.audienceId}/insights`}>
          {audienceName?.split('>')?.at(-1)?.trim() ?? '-'}
        </Link>
        <span>{dayjs(updatedAt).format('YYYY-MM-DD - HH:MM')}</span>
      </div>
      <div className="ai-card__user">
        <p>Created by:</p>
        <p>{createdBy}</p>
      </div>
    </div>
  )
}

const AudienceInsightsBlock = ({ currentUser }) => {
  const [insights, setInsights] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    getInsights(currentUser).then((insights) => {
      setInsights(insights)
      setLoading(false)
    })
  }, [])

  return (
    <Block
      title="Audience Insights"
      link="/audience"
      content={
        loading ? (
          <p className="dashboard__zero-state-message">Loading...</p>
        ) : (
          insights.map((report) => <Card key={report.audienceName} report={report} />)
        )
      }
    />
  )
}

export default AudienceInsightsBlock
